import React, { useState } from "react";
import * as XLSX from "xlsx";
import apiClient from "../api/apiClient";

const ActualizarEntregas = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            setError("Por favor, selecciona un archivo Excel.");
            return;
        }

            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = async (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                // Formatear los datos según el formato esperado
                const formattedData = {
                    Orders: jsonData.map(row => ({
                        DocEntry: row["IDRegistro"],
                        U_VEHICULO: String(row["Camion"]),
                        U_CHOFER: String(row["Chofer"]),
                        U_dKmR: String(row["Km Estimado"]),
                        Comments: String(row["Comentario"]),
                    }))
                };

                // Enviar los datos al backend
                const response = await apiClient.patch("/delivery/update", formattedData);
                
                // Procesar la respuesta
                const results = response.data || [];
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} remisiones actualizadas con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} remisiones sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la actualización.\n`;
                }

                setMessage(messageText);
                if (messageText) alert(messageText);
                setError("");
                setFile(null);
                document.getElementById("fileUpload").value = "";

            };
    };

    return (
        <div className="container mt-4">
            <h2>Cargar Lista de Entregas</h2>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
                <input type="file" id="fileUpload" className="form-control" accept=".xlsx" onChange={handleFileChange} />
            </div>
            <button className="btn btn-primary" onClick={handleUpload}>
                Actualizar Entregas
            </button>
        </div>
    );
};

export default ActualizarEntregas;
